import api from './api';

export const adminAPI = {
  getTenants: () => api.get('/admin/tenants'),
  getTenant: (id) => api.get(`/admin/tenants/${id}`),
  createTenant: (data) => api.post('/admin/tenants', data),
  deactivateTenant: (id) => api.post(`/admin/tenants/${id}/deactivate`),
  activateTenant: (id) => api.post(`/admin/tenants/${id}/activate`),
  getPlatformUsers: () => api.get('/admin/users'),
  getUsers: (tenantId) => api.get(`/admin/tenants/${tenantId}/users`),
  createUser: (tenantId, data) => api.post(`/admin/tenants/${tenantId}/users`, data),
  updateUser: (userId, data) => api.put(`/admin/users/${userId}`, data),
  getAuditLog: (params) => api.get('/admin/audit-log', { params }),
  getRegenReport: (params) => api.get('/admin/regeneration', { params }),
  getPendingApprovals: (tenantId) => api.get(`/admin/tenants/${tenantId}/regeneration/pending`),
  approveRegeneration: (jobId) => api.post(`/admin/regeneration/${jobId}/approve`),
  rejectRegeneration: (jobId) => api.post(`/admin/regeneration/${jobId}/reject`),
  getModelAccuracy: () => api.get('/admin/model-accuracy'),
  getModelHistory: (language) => api.get(`/admin/model-accuracy/${language}/history`),
  getCompliance: () => api.get('/admin/compliance'),
  getPlatformMetrics: () => api.get('/admin/platform/metrics'),
  getPlatformUtilisation: (params) => api.get('/admin/platform/utilisation', { params }),
  getTenantSettings: (tenantId) => api.get(`/admin/tenants/${tenantId}/settings`),
  updateTenantSettings: (tenantId, data) => api.put(`/admin/tenants/${tenantId}/settings`, data),
  getLanguageThresholds: () => api.get('/admin/model-accuracy/thresholds'),
  getPlatformLanguages: () => api.get('/config/languages/all'),
  updatePlatformLanguage: (code, data) => api.patch(`/config/languages/${code}`, data),
  isTenantActive: (tenantId) => api.get(`/admin/tenants/${tenantId}/active`),
  checkRegenApprovalRequired: (tenantId, sourceId) =>
    api.get(`/admin/tenants/${tenantId}/regeneration/check`, {
      params: { source_id: sourceId },
    }),
};

export default adminAPI;
